import { mutatorAction } from 'satcheljs';
import { getActivityFeedStore } from '../store/store';
import { ActivityFeedStorageItem, ActivityType } from '../service/ActivityFeedStorageItem';
import { isFeatureEnabled } from 'owa-feature-flags';
import { getActivityFeedItem } from '../utils/ActivityFeedHelpers';
import { getPromptFeedAction } from '../store/feedActionSelector';
import { getPromptFeedActionCard } from './getPromptFeedActionCard';

export const activityFeedLoaded = mutatorAction(
    'ACTIVITY_FEED_LOADED',
    (items: Array<ActivityFeedStorageItem>) => {
        const store = getActivityFeedStore();
        store.firstFetchComplete = true;
        if (items) {
            // an ObservableMap preserves insertion order, hence clearing to ensure
            // we reflect the order the API payload has.
            store.items.clear();

            // Only possible if hosted by monarch native host
            // If an update to native host is available, we add
            // a card prompting the user to restart
            if (getPromptFeedAction()) {
                const cardId = 'LocalActivity-PromptAction';
                const card = getPromptFeedActionCard(cardId);
                store.items.set(cardId, card);
            }

            const predicate = (item: ActivityFeedStorageItem): boolean => {
                return supportedActivity(
                    item,
                    isFeatureEnabled('auth-activityFeedRenderFileActivity'),
                    isFeatureEnabled('auth-activityFeedRenderMyAnalytics'),
                    isFeatureEnabled('auth-activityFeedRenderOutOfRoutine'),
                    isFeatureEnabled('auth-activityFeedRenderRealTimeFlight'),
                    isFeatureEnabled('auth-activityFeedRenderYammerLiveEvent'),
                    isFeatureEnabled('auth-activityFeedRenderReaction') &&
                        isFeatureEnabled('rp-reactions'),
                    isFeatureEnabled('auth-activityFeedRenderFileActivity')
                );
            };

            items.filter(predicate).forEach(item => {
                store.items.set(item.id, getActivityFeedItem(item));
            });
        } else {
            // action was called with no items indicating no items so clear the store
            store.items.clear();
        }
    }
);

function supportedActivity(
    item: ActivityFeedStorageItem,
    userAtMentionSupport: boolean,
    myAnalyticsSupport: boolean,
    outOfRoutineSupport: boolean,
    realTimeFlightUpdateSupport: boolean,
    yammerLiveEventSupport: boolean,
    reactionSupport: boolean,
    fileActivitySupport: boolean
): boolean {
    if (item.type == undefined || item.type == null) {
        return false;
    }

    switch (item.type) {
        case ActivityType.Like:
        case ActivityType.AtMention:
        case ActivityType.TxpParcelDelivery:
        case ActivityType.TxpFlightReservation:
            return true;
        case ActivityType.UserAtMentioned:
            return userAtMentionSupport;
        case ActivityType.TaskNotificationInsight:
        case ActivityType.FollowUpNotificationInsight:
            return myAnalyticsSupport;
        case ActivityType.OutOfRoutineNotificationInsight:
            return outOfRoutineSupport;
        case ActivityType.RealTimeFlightUpdate:
            return realTimeFlightUpdateSupport;
        case ActivityType.YammerLiveEventNotification:
            return yammerLiveEventSupport;
        case ActivityType.Reactions:
            return reactionSupport;
        case ActivityType.CommentCreated:
        case ActivityType.TaskCreated:
        case ActivityType.TaskCompleted:
        case ActivityType.TaskReopened:
        case ActivityType.TaskReassigned:
            return fileActivitySupport;
        default:
            return false;
    }
}
